<template>
	<section style="overflow-y: auto;height: calc(100vh - 110px);">
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-form :inline="true" :model="filters" class="filterForm">
				<el-form-item label="机构名称:" label-width="100px">
					<el-input v-model="filters.schoolName" auto-complete="off" class="formItem" size="small" />
				</el-form-item>
				<el-form-item label="用户名:" label-width="100px">
					<el-input v-model="filters.logName" auto-complete="off" class="formItem" size="small" />
				</el-form-item>
				<el-form-item label="负责人:" label-width="100px">
					<el-input v-model="filters.teamPerson" auto-complete="off" class="formItem" size="small" />
				</el-form-item>
				<el-form-item label="联系电话:" label-width="100px">
					<el-input v-model="filters.linkTel" auto-complete="off" class="formItem" size="small" />
				</el-form-item>
				<el-form-item label="状态:" label-width="100px" prop="status">
					<el-select v-model="filters.status" placeholder="请选择" size="small" class="formItem" clearable>
						<el-option v-for="item in lvUserStatusDict" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" v-on:click="getGridData" size="small">查询</el-button>
					<el-button type="primary" @click="addInfo" size="small">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<!--列表-->
		<el-table :data="grid_data" height="calc(66vh)" border highlight-current-row v-loading="listLoading"
			@selection-change="(v) => { sels = v }" style="width: 100%;">
			<el-table-column type="selection" width="55">
			</el-table-column>

			<el-table-column prop="schoolCode" label="机构编号" width="100"></el-table-column>
			<el-table-column prop="schoolName" label="机构名称" width="200"></el-table-column>
			<el-table-column prop="logName" label="用户名" width="100"></el-table-column>
			<el-table-column prop="bookVersionName" label="教材版本" width="100"></el-table-column>
			<el-table-column prop="status" label="启用" width="80" :formatter="$util.yesOrNo"></el-table-column>
			<el-table-column prop="cAddress" label="详细地址" width="150"></el-table-column>
			<el-table-column prop="teamPerson" label="负责人" width="150"></el-table-column>
			<el-table-column prop="linkTel" label="联系电话" width="150"></el-table-column>
			<el-table-column prop="addTime" label="添加时间" width="140" :formatter="$util.dateFormatEx"></el-table-column>
			<el-table-column label="操作" min-width="160" fixed="right">
				<template scope="scope">
					<el-button size="small" @click="editInfo(scope.$index, scope.row)">编辑</el-button>
					<el-button size="small" @click="updateStatus(scope.$index, scope.row)"
						v-if="scope.row.status==1">禁用</el-button>
					<el-button size="small" @click="updateStatus(scope.$index, scope.row)" v-else>启用</el-button>
					<el-button size="small" @click="delInfo(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!--分页-->
		<pagination :totalPage="total" :currentPage="filters.page" :pageSize="filters.rows"
			@pageSizeCallBack="handleSizeChange" @currentPageCallBack="handleCurrentChange"></pagination>
		<addsave :showTitle="showTitle" :dialogAddShow="dialogAddShow" :mid="mid" @saveCallBack="saveCallBack"
			@getVisible="(v) => { dialogAddShow = v }"></addsave>
	</section>
</template>
<script>
import pagination from '@/components/common/pagination.vue'
import addsave from './schoolinfoadd.vue'
export default {
	components: { addsave, pagination },
	data() {
		return {
			filters: {
				id: 0,
				schoolName: '',
				logName: '',
				teamPerson: '',
				linkTel: '',
				status: '',
				rows: 10,
				page: 1
			},
			grid_data: [],
			total: 0,
			listLoading: false,
			sels: [],//列表选中列
			showTitle: "",
			dialogAddShow: false,
			mid: 0
		}
	},
	methods: {
		//获取列表
		getGridData() {
			this.listLoading = true;
			let formData = this.$util.jsonToForm(this.filters);
			this.$axios.post("/school/getschoolinfolist", formData).then(res => {
				this.listLoading = false;
				this.total = res.data.total;
				this.grid_data = res.data.data;
			});
		},
		//删除
		delInfo: function (index, row) {
			this.$confirm('确认删除该记录吗?', '提示', {
				type: 'warning'
			}).then(() => {
				let formData = new FormData();
				formData.append("id", row.id);
				this.$axios.post("/school/schoolinfodel", formData).then(res => {
					if (res.data.status == 0) {
						this.$message("删除成功!");
						this.getGridData();
					} else {
						this.$message(res.data.msg);
					}
				});
			});
		},
		addInfo: function () {
			this.showTitle = "新增机构";
			this.dialogAddShow = true;
			this.mid = 0;
		},
		editInfo: function (index, row) {
			this.showTitle = "编辑机构";
			this.dialogAddShow = true;
			this.mid = row.id;
		},
		updateStatus: function (index, row) {
			let formData = new FormData();
				formData.append("id", row.id);
				formData.append("status",row.status==1?0:1)
				this.$axios.post("/school/schoolinfoupdate_status", formData).then(res => {
					if (res.data.status == 0) {
						this.$message(row.status==1?"禁用":"启用"+"成功!");
						this.getGridData();
					} else {
						this.$message(res.data.msg);
					}
				});
		},
		saveCallBack: function () {
			this.dialogAddShow = false;
			if (this.mid == 0) {
				this.handleCurrentChange(1);
			}
			else {
				this.getGridData();
			}
		},
	},
	async created() {
		this.getGridData();
	}
}

</script>

<style scoped></style>
